import template from './textCircle.html';
import './textCircle.scss';

export const TextCircle = angular
    .module('checkout.components.accordian.textCircle', [])
    .component('textCircle', {
        template,
        transclude: true,
        bindings: {
            lightTheme: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/accordian/components/textCircle/textCircle.js